export const OVERALL_BUSINESS_PROFILE_STATUS_LABELS = {
  PENDING: 'Pending',
  ONBOARDED: 'Registered',
};

export const OVERALL_BUSINESS_PROFILE_STATUS_COLORS = {
  PENDING: 'warning',
  ONBOARDED: 'success',
};

export const BUSINESS_PROFILE_PENDING_STATUS = 'PENDING';
export const BUSINESS_PROFILE_ONBOARDED_STATUS = 'ONBOARDED';

export const canRegisterBusinessProfile = (profile) =>
  !profile?.status || profile.status === BUSINESS_PROFILE_PENDING_STATUS;

export const canDeregisterBusinessProfile = (profile) =>
  profile?.status === BUSINESS_PROFILE_ONBOARDED_STATUS;

export const isBusinessProfileRegistered = (profile) =>
  profile?.status === BUSINESS_PROFILE_ONBOARDED_STATUS;
